import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNodeDotJsComponent } from './simple-icons-node-dot-js.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNodeDotJsComponent ],
    exports:      [ SimpleIconsNodeDotJsComponent ],
    bootstrap:    []
})
export class SimpleIconsNodeDotJsModule {}
